export const PHONE = "phone"
export const PROFILE_PHOTO = "profilePhoto"
export const LICENSE = "license"
export const INSURANCE = "insurance"
export const RESUME = "resume"
export const EXPERIENCE = "experience"
export const PROFILE_ADDRESS = "profileAddress"
export const EMAIL = "email"
export const AGE_QUESTION = "ageQuestion"
export const AGE_QUESTION_ERROR = "ageQuestionError"
export const ENDORSEMENT_QUESTION = "endorsementQuestion"
export const PARTNER_LICENSE = "partnerLicense"
export const ADDITIONAL_DOCS = "additionalDocs"